import { _post } from "@/utils/request.js";
const preApi = process.env.NODE_ENV !== "production" ? "/api" : process.env.VUE_APP_API;
const URL = {
  enhancer: preApi + "/ai/image_enhancer/pre",
  download: preApi + "/ai/image_enhancer/download",
  batch: preApi + "/ai/image_enhancer/batch",
  asyncResult: preApi + "/task/task/image_enhancer",
};

//单张高清化
const getEnhancerResult = async (data) => _post(URL.enhancer, data);

//单张下载
const downloadFile = async (data) => _post(URL.download, data);

//高清化 批量上传
const getBatchTaskId = async (data) => _post(URL.batch, data);

//查询异步任务结果
const getAsyncResult = async (data) => _post(URL.asyncResult, data);

export { getEnhancerResult, downloadFile, getBatchTaskId, getAsyncResult };
